export enum SignUpType {
  GENERIC = "1",
  AUTO = "auto",
  FACEBOOK = "facebook",
  PRODUCT = "product",
  BRAND = "brand",
  FAIRE_DIRECT = "direct",
  WIDGET = "widget",
  WIDGET_V2 = "widgetv2",
  SHOPIFY_WIDGET = "shopifywidget",
  FAIRE_DIRECT_REQUIRE_EMAIL = "directrequireemail",
  TRADESHOW = "tradeshow",
  RETAILER_SUBUSER = "retailersubuser",
  RETAILER_LEAD_ADS = "retailerleadads",
  FOI_BANNER = "foibanner",
  PAID_ADS = "paidads",
  SEM = "sem",
  NAV_ACCOUNT = "nav_account",
  NAV_CART = "nav_cart",
  SEO_DISCOVER = "seo_discover",
}
